module.exports = __webpack_public_path__ + "img/person-centered.cbe72d35.svg";